/** @jsxImportSource @emotion/react */
import React from "react";

import { ComponentContainerProps } from "./types";
import * as styles from "./styles";

export const ComponentContainer = React.forwardRef(
  (
    {
      children,
      className = "",
      size = "md",
      sizes = { sm: 1000, md: 1400, lg: 1600 },
      ...props
    }: ComponentContainerProps,
    ref: any
  ) => {
    return (
      <div
        ref={ref}
        className={`container ${className}`}
        css={styles.div({
          size,
          sizes,
        })}
        {...props}
      >
        {children}
      </div>
    );
  }
);
